import { Polygon, Tooltip } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { useGeofenceViolations } from '../../hooks/useGeofenceViolations';

/**
 * The selected drone's inclusion geofence, drawn on the planner map (#451).
 *
 * The operator has to see where they are allowed to fly *before* placing
 * anything — the alternative is finding out on save, after the route is drawn.
 *
 * Rendered beneath the route and markers, and non-interactive: this is a
 * boundary the geofence API owns, not a draft shape to be edited here. A
 * dashed stroke separates it from the solid survey-area shapes the operator
 * *can* edit, so the two are distinguishable without relying on colour.
 */
export const GeofenceLayer: React.FC = () => {
  const { enforced, vertices } = useGeofenceViolations();
  const geofenceName = useSelector(
    (state: RootState) => state.geofence.geofence?.name
  );

  if (!enforced || vertices.length === 0) {
    return null;
  }

  return (
    <Polygon
      positions={vertices}
      interactive={false}
      pathOptions={{
        color: '#0072b2',
        weight: 2,
        dashArray: '6 6',
        fillColor: '#0072b2',
        fillOpacity: 0.06,
      }}
    >
      <Tooltip sticky>
        <strong>{geofenceName ?? 'Geofence'}</strong>
        <br />
        Waypoints must stay inside this zone.
      </Tooltip>
    </Polygon>
  );
};
